<form [formGroup]="form">
  <section fxLayout="column" fxLayoutAlign=" start">
    <mat-form-field appearance="outline" fxFlexAlign="stretch" *ngIf="(defectList$ | async)?.length > 0">
      <mat-label>Festgestellte Defekte</mat-label>
      <mat-select multiple [formControl]="form.controls.selectedDefects">
        <mat-option
          class="defect-option"
          *ngFor="let defect of defectList$ | async; index as defectIndex"
          [value]="defect.description">
          {{ defect.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="margin-bottom: 0.5rem" fxFlexAlign="stretch">
      <mat-label>Beschreibung</mat-label>
      <textarea
        matInput
        type="text"
        rows="3"
        maxlength="1500"
        required
        [formControl]="form.controls.comment"></textarea>
    </mat-form-field>
  </section>
</form>

<div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
  <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
  <button
    mat-raised-button
    color="primary"
    id="modal-confirm-after-meter-change"
    (click)="confirm()"
    [disabled]="!isFormValid">
    <span>Mängel melden</span>
  </button>
</div>
